module.exports = __webpack_public_path__ + "img/Seite5-papa.ca2db25d.png";